import React from "react";

type BaseCircleProps = {
  r: number;
  stroke: string;
  strokeWidth: number;
  strokeDasharray?: number;
  strokeDashoffset?: number;
  transform?: string;
  style?: React.CSSProperties;
};

const BaseCircle: React.FC<BaseCircleProps> = ({
  r,
  stroke,
  strokeWidth,
  strokeDasharray,
  strokeDashoffset,
  transform = "rotate(90 12 12)",
  style,
}) => {
  return (
    <circle
      cx="12"
      cy="12"
      r={r}
      stroke={stroke}
      strokeWidth={strokeWidth}
      fill="none"
      strokeDasharray={strokeDasharray}
      strokeDashoffset={strokeDashoffset}
      strokeLinecap="round"
      transform={transform}
      style={style}
      role="img"
    />
  );
};

export default BaseCircle;
